var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandbagHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29379",
    "data-name": "Group 29379",
    transform: "translate(-422 -182.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(422 182.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_10_",
    "data-name": "svgexport-17 (10)",
    transform: "translate(440 191.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49874",
    "data-name": "Path 49874",
    d: "M17.152,171l-1.375-7.974H1.481L.106,171a6.935,6.935,0,0,0-.094,1.578c.045.776.18,1.765.575,1.765H16.67c.4,0,.53-.989.575-1.765A6.918,6.918,0,0,0,17.152,171",
    transform: "translate(-0.001 -157.966)",
    fill: "#894b9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49875",
    "data-name": "Path 49875",
    d: "M151.226,164.221h-1.08a.354.354,0,0,1-.354-.353v-.838h1.787v.838a.354.354,0,0,1-.354.354m-.838,2.085h.6v-2.085h-.6Z",
    transform: "translate(-144.739 -157.967)",
    fill: "#69357c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49876",
    "data-name": "Path 49876",
    d: "M143.344,252.5a1.191,1.191,0,1,1-1.191-1.191,1.191,1.191,0,0,1,1.191,1.191",
    transform: "translate(-136.205 -243.265)",
    fill: "#f0c419"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49877",
    "data-name": "Path 49877",
    d: "M6.244,22.491h-.6a.3.3,0,1,1,0-.6h.6a.3.3,0,1,1,0,.6m7.408-4.467c-.3-1.872-1.613-5.063-4.728-5.063S4.5,16.152,4.2,18.024H5.413a7.7,7.7,0,0,1,.632-1.844,3.173,3.173,0,0,1,2.879-2.028A3.173,3.173,0,0,1,11.8,16.18a7.7,7.7,0,0,1,.632,1.844Zm-12.174,0L.1,26A6.934,6.934,0,0,0,.01,27.576a4.986,4.986,0,0,0,.247,1.447l.031.02s2.68-2.283,2.68-11.02Zm14.3,0L17.15,26a6.934,6.934,0,0,1,.094,1.578A4.986,4.986,0,0,1,17,29.023l-.031.02s-2.68-2.283-2.68-11.02Z",
    transform: "translate(0 -12.961)",
    fill: "#69357c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandbagHighlighted);
export default __webpack_public_path__ + "static/media/HandbagHighlighted.228cebb2f20d5e207d8bc01308019e2f.svg";
export { ForwardRef as ReactComponent };